import { ThemedStyleFn } from '~src/hooks/useStyles';
import { fadeInKeyframes } from '~src/styles/animations';

export const styleFn: ThemedStyleFn = (theme) => ({
  container: {
    userSelect: 'none',
    height: '100%',
    position: 'relative',
  },
  icons: {
    color: theme.colors.secondary,
    fontSize: '20px',
    margin: '0 2px',
  },
  small: {
    fontSize: '16px',
  },
  table: {
    '.ant-table-row': {
      animation: `${fadeInKeyframes} 0.3s ease-out`,
      cursor: 'pointer',

      '&.unfinished > td': {
        color: 'rgba(0, 0, 0, 0.25)',
      },
    },
  },
  panelsContainer: {
    position: 'absolute',
    left: 0,
    bottom: 0,
    width: '100%',
  },
  fadeInContainer: {
    animation: `${fadeInKeyframes} 0.3s ease-out`,
  },
});
